import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { map } from 'rxjs/operators';
import { AppComponent } from 'src/app/app.component';
import { DataService } from 'src/app/services/data.service';
import { ErrorHandlerService } from 'src/app/services/error-handler.service';
import { LoaderService } from 'src/app/services/loader.service';
import { ToastService } from 'src/app/services/toast.service';

@Component({
  selector: 'app-manager',
  templateUrl: './manager.page.html',
  styleUrls: ['./manager.page.scss'],
})
export class ManagerPage  {
  employees=[];
  loaded=false
  width = window.innerWidth;
  constructor(
    private errorHandlerSRV:ErrorHandlerService,
    private loaderSRV:LoaderService,
    private appComp:AppComponent,
    private toastSRV:ToastService,
    public dataService: DataService,
    private router: Router,
    public translateService: TranslateService,
  ) { }

  ionViewDidEnter() {
    this.employees=[]
    this.getCompanyUsers()
  }
  loginAsEmployee(id){
    this.loaderSRV.showLoader(this.translateService.instant('keys.data.common.loading') || 'Loading...')
    this.dataService.getData(`company_managers/${id}/login_as`).subscribe({
      next:data=>{
        if(data['status']=="success"){
          this.toastSRV.presentToast(data['message'])
          this.dataService.storeData("temp",
          {"tempLoggedIn":true,
            "ID":this.dataService.user['UserID']}).then(()=>{
              this.router.navigate(['home']);
            this.dataService.isTemp=true
            this.dataService.user={}
            this.dataService.isAuthenticated.next(false)
            this.dataService.isAuthenticated.next(true)
            this.appComp.initializeApp()
          })
        }
        setTimeout(() => {
          this.loaderSRV.dismissLoader()
        }, 500);
      },
      error:err=>{
        
        this.errorHandlerSRV.displayErrorMessage(err,true)
      }
      
    })
  }
  getCompanyUsers(){
    this.dataService.getData('company_managers').pipe(
      map(data=>{
        var tempEmployees=[]
        if(data['status']=="success"){
          
          
          data['allemployees'].forEach(employee => {
            employee['permits']=[]
            employee['vehicles']=[]
          })
          if(data['permits'].length>0){
            data['permits'].forEach(permit => {
              data['allemployees'].forEach(employee => {
               
                if(permit['UserID'].toString()==employee['UserID'].toString()){
                  employee['permits'].push({permitNo:permit['PermitNo']})
                }
              });
            });
          }
          
          tempEmployees=data['allemployees']
         
          
          tempEmployees.forEach(employeeA => {
            data['allemployees'].forEach(employeeB => {
              if(employeeA['UserID']==employeeB['UserID'] ){
                employeeA['vehicles'].push({plate:employeeB['Plate']})
              }
            })
          })
          this.employees =  [...new Map(tempEmployees.map(res => [res.UserID, res])).values()]
          
          
          
          
          
          this.loaded=true
         }
         else {
            this.loaded=true
            return
            
         }
       
        
      })
    ).subscribe({
      error:err=>{
        this.errorHandlerSRV.displayErrorMessage(err,true)
      }
       
      
    })
  }
}
